// Settings, Templates in plain words (spec C14): the page, the editor and its messages.

export const fieldLabel = { to: 'To', cc: 'CC', subject: 'Subject', body: 'Body' } as const;

export const templateCopy = {
  title: 'Email templates',
  sub: 'The emails to the insured. The Email insured step fills them in on each record.',
  readOnly: 'Only the Admin changes templates in Phase 1. The Manager can from Phase 2.',
  email: 'Email',
  insert: 'Insert a value',
  blocksNote:
    'Blocks: {{#mortgagee}} ... {{/mortgagee}} shows only when there is a mortgagee; the same for escrowed, not_escrowed and due_to_safeside. {{^mortgagee}} ... {{/mortgagee}} shows only when there is none. Text in [ ] is left for the VA to fill in.',
  preview: 'Preview on a made-up record',
  previewBlocks: 'Blocks shown in the preview',
  previewTo: (to: string, cc: string) => `To: ${to || 'none'}${cc ? `, CC: ${cc}` : ''}`,
  unknown: (keys: string[]) =>
    `Not a value the portal knows: ${keys.map((k) => `{{${k}}}`).join(', ')}. Use Insert a value.`,
  history: 'History',
  hideHistory: 'Hide history',
  historyCount: (n: number) => (n === 1 ? 'History (1 change)' : `History (${n} changes)`),
  noHistory: 'No changes yet. This is the department template.',
  cancel: 'Cancel',
  close: 'Close',
  save: 'Save',
  unsaved: 'Unsaved changes',
  saved: (name: string) => `${name} saved.`,
  reset: 'Reset to default',
  resetDone: (name: string) => `${name} is back to the department template.`,
  resetTitle: (name: string) => `Reset ${name}?`,
  resetLine: 'The department template replaces your changes. The History keeps them.',
  discard: 'Discard',
  keepEditing: 'Keep editing',
  discardTitle: (name: string) => `Discard changes to ${name}?`,
  discardLine: 'Your changes to this template are not saved.',
  somethingWrong: 'Something went wrong. Try again.',
  edited: 'Edited',
  standard: 'Department template',
};

/** Why a save did not go through. */
export function saveError(error: string, body: Record<string, unknown>): string {
  if (error === 'unknown_placeholder' && Array.isArray(body.unknown)) {
    return templateCopy.unknown(body.unknown as string[]);
  }
  if (error === 'bad_template') return 'The subject and the body cannot be empty.';
  if (error === 'forbidden') return templateCopy.readOnly;
  return templateCopy.somethingWrong;
}
